const initialState = {
	error: false,
	message: "",
	title: "",
	shopSales: [],
	shopItems: [],
};

//selectors
export const getShopItems = (state) => state.shop;

//reducers
export const shopReducer = (state = initialState, action) => {
	// console.log("I am the SHOP reducer action ======> ", action);
	switch (action.type) {
		// case "SHOP":
		// 	return {
		// 		...state,
		// 		error: false,
		// 		shopItems: action.payload,
		// 	};
		case "PURCHASE":
			return {
				...state,
				error: false,
				title: action.message,
				shopSales: action.payload,
			};
		default:
			return {
				...state,
			};
	}
};
